module.exports = __webpack_public_path__ + "img/data.4ffa0c09e3ce97cfb3244c087d43c83c.svg";